import { ICouponPrintDiscount } from 'modules/shop/types/coupon';
import CouponUI from './CouponUI';
type Props = {
  data: ICouponPrintDiscount[];
};
const CouponDiscount = ({ data }: Props) => {
  if (!data.length) return null;

  return (
    <>
      {data.map((o, i) => (<CouponUI data={o} key={i} />))}
    </>
  );
};

export default CouponDiscount;
